import {create} from 'zustand';

type Store = {
  cart : any;
  setCart: (value: any) => void;
  clearCart :()=> void
};

export const useCartStore = create<Store>((set) => ({
  cart: null,

  setCart: (value: any) => set({ cart: value }),
  clearCart: () => set({cart : null}),
}));

